import {
    ISameCaseMatchResponseModel,
    ISameCaseMatchedCasesSearchModel,
    SameCaseSortColumns,
} from '../../../../pages/quad/same-cases-admin/manage/useGetSameCasesQuery';

import { IPagedSortedSearchResponseModel } from '../../../../interfaces/PagedSortedSearch';
import { NoResultsDisplay } from '../NoResultsDisplay';
import { SameCaseManageSearchCaseRow } from './SameCaseManageSearchCaseRow';
import { SortableHeader } from '../../../shared/SortableHeader';
import { Table } from 'react-bootstrap';
import { ToggleIcon } from '../../../../shared/ToggleIcon';
import { useState } from 'react';

export interface ISaveCaseManageSearchResultsProps {
    currentFilters: ISameCaseMatchedCasesSearchModel;
    isFilterPaneOpen: boolean;
    isLoading: boolean;
    newCaseGroupGuidToOpen: string | null;
    onApplyFilters: (filters: ISameCaseMatchedCasesSearchModel) => void;
    onCaseGroupSaved?: (caseGroup: ISameCaseMatchResponseModel) => void;
    onNewCaseGroupSaved?: (
        originalCaseGroup: ISameCaseMatchResponseModel,
        newCaseGroup: ISameCaseMatchResponseModel
    ) => void;
    onSort: (key: string, order: string, subKey?: string) => void;
    onToggleFilterPane: () => void;
    results:
        | IPagedSortedSearchResponseModel<ISameCaseMatchResponseModel, SameCaseSortColumns>
        | undefined;
}

export function SaveCaseManageSearchResults(props: ISaveCaseManageSearchResultsProps) {
    const [activeKeys, setActiveKeys] = useState<string[]>([]);

    const hasRows = (props.results?.results.length ?? 0) > 0;

    const atleastOneExpanded = activeKeys.length > 0;

    const handleExpandCollapseAll = () => {
        atleastOneExpanded ? handleCollapseAll() : handleExpandAll();
    };

    const handleExpandAll = () => {
        setActiveKeys(props.results?.results?.map((sameCaseGroup) => sameCaseGroup.guid) ?? []);
    };

    const handleCollapseAll = () => {
        setActiveKeys([]);
    };

    return (
        <>
            <Table size="sm">
                <thead>
                    <tr style={{ verticalAlign: 'middle' }}>
                        <th style={{ width: '20px' }}>
                            <ToggleIcon
                                onClick={handleExpandCollapseAll}
                                isOpen={atleastOneExpanded}
                            />
                        </th>
                        <SortableHeader
                            active={
                                props.currentFilters.sortModel.sortColumn ===
                                SameCaseSortColumns.CaseNumber
                            }
                            currentSortModel={props.currentFilters.sortModel}
                            headerText="Case Number"
                            sortKey={SameCaseSortColumns.CaseNumber.toString()}
                            onSort={props.onSort}
                            noWrap
                            thStyle={{ width: 200 }}
                        />
                        <SortableHeader
                            active={
                                props.currentFilters.sortModel.sortColumn ===
                                SameCaseSortColumns.Jurisdiction
                            }
                            currentSortModel={props.currentFilters.sortModel}
                            headerText="Jurisdiction"
                            sortKey={SameCaseSortColumns.Jurisdiction.toString()}
                            onSort={props.onSort}
                            noWrap
                            thStyle={{ width: 200 }}
                        />
                        <SortableHeader
                            active={
                                props.currentFilters.sortModel.sortColumn ===
                                SameCaseSortColumns.CaseName
                            }
                            currentSortModel={props.currentFilters.sortModel}
                            headerText="Case Name"
                            sortKey={SameCaseSortColumns.CaseName.toString()}
                            onSort={props.onSort}
                            noWrap
                        />
                    </tr>
                </thead>
                <tbody>
                    {props.results?.results?.map((caseGroup: ISameCaseMatchResponseModel) => {
                        var key = `${caseGroup.caseNumber}-${caseGroup.caseName}-${caseGroup.jurisdiction}-${caseGroup.guid}-${caseGroup.caseFileModelId}-${caseGroup.matchedCases.length}`;

                        return (
                            <SameCaseManageSearchCaseRow
                                key={key}
                                activeKeys={activeKeys}
                                caseGroup={caseGroup}
                                currentCaseGroupsInEditMode={[]}
                                currentFilters={props.currentFilters}
                                newCaseGroupGuidToOpen={props.newCaseGroupGuidToOpen}
                                onCaseGroupSaved={props.onCaseGroupSaved}
                                onNewCaseGroupSaved={props.onNewCaseGroupSaved}
                                onToggleActiveKeys={setActiveKeys}
                            />
                        );
                    })}
                </tbody>
            </Table>

            <NoResultsDisplay
                onShowFiltersClick={() => props.onToggleFilterPane()}
                show={!hasRows && !props.isLoading}
            />
        </>
    );
}
